import { type WalletExternalAddress } from '@capsicum/common';
import { useQuery } from '@tanstack/react-query';

import { fetchExternalAddressById } from '../api';

/**
 * @param recipientId
 * @returns WalletExternalAddress
 */
export const useWalletExternalAddressQuery = <TData = undefined | WalletExternalAddress>(
	recipientId: string | undefined,
	select: (data: undefined | WalletExternalAddress) => TData
) =>
	useQuery({
		enabled: !!recipientId,
		queryFn: () => fetchExternalAddressById(recipientId ?? ''),
		queryKey: ['fetchExternalAddressById', recipientId],
		select: select
	});
